module.exports = __webpack_public_path__ + "static/media/coreimg2.24f42a9f.png";